/* 🤖 this file was generated by svg-to-ts */
export const matIconFlashOn: {
  name: 'flash-on';
  data: string;
} = {
  name: 'flash-on',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 2v11h3v9l7-12h-4l3-8z"/></svg>`
};
